import React from 'react';
import { BrowserRouter as Router, Switch, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';

import './App.scss';
import setAuthToken from './utils/setAuthToken';
import AppWrapper from './components/AppWrapper';
import Navbar from './components/Navbar';
if (localStorage.token) {
  setAuthToken(localStorage.token);
}

// The landing page ships with its own header, so the app navbar stays out of its way.
const AppNavbar = () => {
  const { pathname } = useLocation();
  if (pathname === '/login') {
    return null;
  }
  return <Navbar />;
};

const App = () => {
  if (window.location.search.includes('captcha')) {
    window.location.replace(window.location.pathname);
  }
  return (
    <Provider store={store}>
      <div className='container'>
        <Router>
          <AppNavbar />
          <Switch>
            <AppWrapper />
          </Switch>
        </Router>
      </div>
    </Provider>
  );
};

export default App;
